"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.commandHandler = void 0;
const commandHandler = (command, params) => {
    if (command === 'getRootNode') {
        return window.document.getRootNode();
    }
    throw new Error(`Unsupported command ${command}`);
};
exports.commandHandler = commandHandler;
